import ImageUploadArea from "components/ImageUploadArea";
import { LogoConfigModel, ProductConfigProps } from "models/WebShop";
import { useEffect, useState } from "react";
import { toBase64, urlToFile } from "utility/ImgUtilities";

const LogoConfig = ({ config, handleOnChange, handleFormValidation }: ProductConfigProps<LogoConfigModel>) => {


    const initialConfig = config?.[0];

    const [initialImg, setInitialImg] = useState<File | null>(null);
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (!initialized && initialConfig?.publicUrlTransform) {
            async function convertImage() {
                const file = await urlToFile(initialConfig.publicUrlTransform, 'logo.png', 'image/png');
                setInitialImg(file);
                setInitialized(true);
            }
            convertImage();
        }
    }, [initialConfig, initialized]);

    const handleAdd = async (imgFile: File | null) => {
        if (imgFile !== null) {
            let encodedImg = await toBase64(imgFile as File) as string;
            let newConfig: LogoConfigModel = {
                publicUrlTransform: encodedImg,
                crmPublishLineId: initialConfig.crmPublishLineId,
                crmProductId: initialConfig.crmProductId
            }
            handleOnChange([newConfig]);
            handleFormValidation(true);
        }
        else {
            handleFormValidation(false);
        }
    }
    return <>

    <div className="d-flex flex-column flex-md-row gap-4 mb-3 mb-md-4">
        <div className="order-md-last text-center">
          <img src="/min-bedrift-ill-logo.svg" width="800" height="270" alt="Logo" className="img-fluid cc-mw-220"></img>
        </div>
        <div>
          <ul className="text-muted mb-0 cc-ul-spaced-1">
            <li>Bli gjenkjent i søkeresultatet og gi et profesjonelt inntrykk.</li>
            <li>Øk tilliten, styrk merkevaren og få flere klikk fra kunder som søker etter dine tjenester. </li>
            <li>En enkel investering som gir stor synlighet.</li>
          </ul>
        </div>
      </div>
        {initialized && <ImageUploadArea onFileChange={handleAdd} initialImg={initialImg} />}
        <p className="text-muted mb-0 lh-sm cc-fs-xs ">Logoen du laster opp skal være et varemerke eller grafisk symbol som representerer firmaet ditt. Den må ikke være et bilde av ansatte, personer eller fotografier, da formålet med logoen er å gi virksomheten en gjenkjennelig og profesjonell identitet.</p>
    </>
}

export default LogoConfig;